
import { Navigate } from 'react-router-dom';
import { getLocalStorage } from 'hooks/useLocalStorage';

const AuthCheck = ({ children, common }) => {
  if (getLocalStorage('persist:user') === null) {
    return <Navigate to="/login" />;
  }
  return children;
}

export default AuthCheck;